import React from 'react';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import { Helmet } from 'react-helmet';
import { Link } from 'gatsby';
import * as R from 'ramda';
import { Breadcrumb, Carousel } from '@cowsquare/design';
import defaultCover from '../../../asset/defaultCover.jpg';
import { Section } from '../../../components/Section';
import { dateFormat } from '../../../utils/dateFormat';
import { ArticleContent } from '../../ArticleContent';
import { BreadcrumbWrapper } from '../../BreadcrumbWrapper';

const GET_MEDIA_RELEASES_RECORD = gql`
  query getMediaReleasesRecord($id: uuid!) {
    record: hkdutest_media_releases_by_pk(id: $id) {
      id
      author {
        name
        email
      }
      name
      content
      cover_file {
        link
      }
      created_at
    }
  }
`;

const Content = ({ id, uri }) => {
  const { data } = useQuery(GET_MEDIA_RELEASES_RECORD, {
    variables: { id },
  });
  const record = R.propOr({}, 'record', data);
  const coverUrl = R.pathOr(defaultCover, ['cover_file', 'link'], record);
  const title = R.propOr('', 'name', record);
  const content = R.propOr('', 'content', record);
  const authorName = R.pathOr('', ['author', 'name'], record);
  const createdAt = R.propOr(null, 'created_at', record);
  const info = `${authorName} Published at ${createdAt ? dateFormat(createdAt) : ''}`;

  return (
    <Section>
      <Helmet>
        <title>{title} - HKDU Public</title>
      </Helmet>
      <Carousel>
        <Carousel.Slide backgroundImage={`url(${coverUrl})`} height={['150px', '300px']} />
      </Carousel>
      <BreadcrumbWrapper>
        <Breadcrumb>
          <Breadcrumb.Item linkProps={{ as: Link, to: R.replace(id, '', uri) }}>
            Media Release
          </Breadcrumb.Item>
          <Breadcrumb.Item>{title}</Breadcrumb.Item>
        </Breadcrumb>
      </BreadcrumbWrapper>
      <ArticleContent title={title} info={info} content={content} />
    </Section>
  );
};

export default Content;
